module.exports = __webpack_public_path__ + "img/video-thumb-1-nl.ffad1af9.png";